import { useState } from 'react';
import { Lock, Loader2, ArrowUpRight } from 'lucide-react';
import { adminApi, setToken, formatApiError } from '@/lib/adminApi';

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await adminApi.post('/admin/login', { password });
      setToken(data.token);
      onSuccess();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-night px-6 pt-20 text-bone">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-coal/40 p-8" data-testid="admin-login-form">
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-turmeric/40 text-turmeric">
          <Lock className="h-4 w-4" strokeWidth={1.5} />
        </span>
        <p className="mt-6 text-[11px] font-medium uppercase tracking-[0.28em] text-turmeric">Trade desk</p>
        <h1 className="mt-2 font-serif text-3xl font-medium text-bone">Private access</h1>
        <p className="mt-2 text-sm text-dune">Enter the admin password to view enquiries.</p>
        <label htmlFor="admin-password" className="mt-8 block text-[11px] font-medium uppercase tracking-[0.22em] text-dune">Password</label>
        <input
          id="admin-password"
          type="password"
          data-testid="admin-password-input"
          autoFocus
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 h-11 w-full rounded-md border border-white/10 bg-night/70 px-4 text-sm text-bone transition-colors duration-300 focus:border-turmeric focus-visible:outline-none"
        />
        {error && <p className="mt-3 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-turmeric px-6 py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em] text-night transition-all duration-300 hover:bg-bone disabled:opacity-60"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Enter <ArrowUpRight className="h-4 w-4" strokeWidth={2} /></>}
        </button>
      </form>
    </div>
  );
}
